import {
  SidePanelDS,
  Assets,
  Spacer,
  LockOutlined,
  TextCapitalized,
  Switch,
  Tag,
  RemoveRedEyeOutlined,
  MessageTooltip,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

type Informations = {
  name: string;
  uuid: string;
  reference?: string;
};

export const InformationsBadge = (props: {
  isBadgeInOpposition: boolean;
  isBadgeLocked: boolean;
  isBadgeToActivate: boolean;
  lockBadge: (isBadgeLocked: boolean, badgeUuid: string) => void;
  vehicle: Informations;
  badgeUuid: string;
  firstPath: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SidePanelDS.Section>
      <StyledAssets>
        <Assets.BadgeLogo />
      </StyledAssets>
      <Spacer y={1.5} />
      <SidePanelDS.ActionBlock>
        <SidePanelDS.SectionedActionStripe
          left={
            <StyledRowCenter>
              <LockOutlined />
              <Spacer x={0.25} />
              <TextCapitalized>{t("badges.sidePanel.lock")}</TextCapitalized>
            </StyledRowCenter>
          }
          right={
            <Switch
              onClick={() =>
                props.lockBadge(!props.isBadgeLocked, props.badgeUuid)
              }
              checked={props.isBadgeLocked || false}
              size={"S"}
              disabled={props.isBadgeInOpposition}
            />
          }
        />
      </SidePanelDS.ActionBlock>
      <Spacer y={1} />
      <SidePanelDS.ActionBlock>
        <SidePanelDS.SectionedActionStripe
          left={
            <StyledRowCenter>
              {props.vehicle.name}
              {props.vehicle.reference && (
                <>
                  <Spacer x={1} />
                  <Tag
                    textColor={colors["colors/text/darkGrey"]}
                    text={props.vehicle.reference}
                    backgroundColor={
                      colors["colors/surfaces/background/background_level0"]
                    }
                    borderColor={colors["colors/text/darkGrey"]}
                  />
                </>
              )}
            </StyledRowCenter>
          }
          right={
            <StyledLittleIcon>
              <RemoveRedEyeOutlined
                key="badgeVehicle"
                onClick={() =>
                  navigate(`/${props.firstPath}/vehicles/${props.vehicle.uuid}`)
                }
              />
              <Spacer x={1} />
            </StyledLittleIcon>
          }
        />
      </SidePanelDS.ActionBlock>
      {props.isBadgeInOpposition && (
        <>
          <Spacer y={1} />
          <MessageTooltip
            title={t("badges.sidePanel.messageTooltip.opposition.title")}
            text={t("badges.sidePanel.messageTooltip.opposition.text")}
            type="ERROR"
          />
        </>
      )}
      {props.isBadgeToActivate && (
        <>
          <Spacer y={1} />
          <MessageTooltip
            title={t("badges.sidePanel.messageTooltip.toActivate.title")}
            text={t("badges.sidePanel.messageTooltip.toActivate.text")}
            type="INFORMATIVE"
          />
        </>
      )}
    </SidePanelDS.Section>
  );
};

const StyledLittleIcon = styled.div`
  display: flex;
  cursor: pointer;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;

const StyledAssets = styled.div`
  display: flex;
  justify-content: center;
  & svg {
    width: 13rem;
    height: 9.5rem;
  }
`;

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
